import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RTextInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    fullWidth?: boolean;
}

export function RTextInput({ value, onChange, placeholder, disabled, fullWidth }: RTextInputProps) {
    return (
        <StyledInput
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            fullWidth={fullWidth}
        />
    );
}

const StyledInput = styled('input')<{ fullWidth?: boolean }>(({ fullWidth }) => ({
    width: fullWidth ? '100%' : 'auto',
    padding: '10px 14px',
    fontSize: 14,
    color: Colors.darkNavy,
    backgroundColor: Colors.faintGrey,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
        borderColor: Colors.mediumGrey,
    },
    '&:disabled': {
        backgroundColor: Colors.lightGrey,
        color: Colors.mediumGrey,
    },
    '&::placeholder': {
        color: Colors.disabledGrey,
    },
}));
